"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[55786],{

/***/ 179185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LazyImage; },
/* harmony export */   "x": function() { return /* binding */ WebpImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => ({
  maxWidth: "100%",
  position: "relative",
  overflow: "hidden",
  flex: "1 0 auto",
  display: "flex",
  cursor: props.onClick ? "pointer" : "unset",
  zIndex: 0,
  margin: "auto",
  borderRadius: props.borderRadius + "px",
  paddingBottom: props.height ? "" : `${100 / props.aspectRatio}%`,
  border: props.border ? "1px solid #e0e0e0" : "",
  height: props.height ? `${props.height}px !important` : "",
  width: props.width ? `${props.width}px` : "100%",
  backgroundImage: props.thumbnail ? `url("${props.thumbnail}")` : null,
  backgroundSize: props.thumbnail ? "cover" : null,
  contentVisibility: props.height && props.width ? "auto" : null
}));
const WebpImage = ({
  src,
  onClick,
  className,
  height,
  width,
  imageWidth,
  alt = "",
  decoding = "async",
  onLoad
}) => {
  const placeHolder = "data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
  let imageUrl = src ? src : placeHolder;
  let altImageUrl = null;
  if (imageUrl && imageUrl.includes("googleusercontent.com")) {
    if (imageWidth || width) {
      imageUrl = `${imageUrl}=w${imageWidth || width}`;
    }
    const checkExt = /=[a-z0-9-]+$/;
    altImageUrl = imageUrl;
    imageUrl = `${imageUrl}${checkExt.test(imageUrl) ? "-rw" : "=rw"}`;
  }
  const imgError = (event) => {
    if (event.target.src !== placeHolder) {
      event.target.src = placeHolder;
    }
    return;
  };
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width,
    height,
    onClick,
    className,
    alt,
    onError: imgError,
    src: imageUrl,
    loading: "lazy",
    decoding,
    onLoad
  });
  return altImageUrl ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: imageUrl,
    type: "image/webp"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: altImageUrl,
    type: "image/png"
  }), imgEle) : imgEle;
};
const WrapperImage = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WebpImage)((props) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: ${props.contain ? "contain" : props.cover ? "cover" : ""};
  transition: transform 0.5s;
  &:hover {
    transform: ${props.hover === "zoom" ? "scale(1.05)" : ""};
  }
  `);
const LazyImage = ({
  src,
  onClick,
  className,
  contain = false,
  cover = false,
  aspectRatio = 1,
  height,
  width,
  alt = "",
  border = false,
  hover = "",
  borderRadius = 0,
  thumbnail,
  decoding = "async",
  imageWidth
}) => {
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperImage, {
    hover,
    className: "lazyload",
    contain,
    imageWidth,
    cover,
    alt,
    "data-src": src,
    src,
    decoding
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height,
    width,
    border,
    aspectRatio,
    borderRadius,
    onClick,
    className,
    thumbnail
  }, imgEle);
};




/***/ }),

/***/ 526439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Currency; },
/* harmony export */   "t": function() { return /* binding */ thoundsandDelimiter; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75537);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function thoundsandDelimiter(number) {
  if (!number) {
    return "0";
  }
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
const StyledCurrency = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  width: max-content;
  display: inline-block;
`;
const Text = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span(({ underline }) => _emotion_react__WEBPACK_IMPORTED_MODULE_2__.css`
    text-decoration: ${underline ? "underline" : ""};
  `);
const Currency = (_a) => {
  var _b = _a, {
    value,
    hideCurrency = false,
    space = false,
    underline = false,
    formattedValue
  } = _b, props = __objRest(_b, [
    "value",
    "hideCurrency",
    "space",
    "underline",
    "formattedValue"
  ]);
  if (!value && value !== 0) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, __spreadValues({}, props), "\xA0");
  }
  if (!!formattedValue) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, __spreadValues({}, props), formattedValue, !hideCurrency && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, space && " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, {
      underline
    }, "\u0111")));
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, __spreadValues({}, props), thoundsandDelimiter(value), !hideCurrency && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, space && " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, {
    underline
  }, "\u0111")));
};




/***/ }),

/***/ 368139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ EmptyCartPanel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(425336);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





const EmptyCartPanel = (_param)=>{
    var props = _extends({}, _param);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, _objectSpreadProps(_objectSpread({
        backgroundColor: "white",
        borderRadius: "m",
        direction: "column",
        justify: "center",
        align: "center",
        padding: "s32"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .LazyImage */ .w, {
                src: "https://shopfront-cdn.tekoapis.com/static/empty_cart.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Description, {
                marginTop: "s16",
                marginBottom: "s24",
                children: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("Giỏ h\xe0ng chưa c\xf3 sản phẩm n\xe0o")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .z, {
                variant: "primary",
                size: "m",
                onClick: ()=>router.push("/"),
                className: "buy-now",
                children: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("Mua sắm ngay")
            })
        ]
    }));
};
const Description = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.neutral;
});


/***/ }),

/***/ 305857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useFormatNumber; }
/* harmony export */ });
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(684443);

const useFormatNumber = ()=>{
    const { numberDisplayFormat  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_0__/* .useTenantConfig */ .Wx)();
    const formatNumber = (number)=>{
        if (!numberDisplayFormat) {
            return undefined;
        } else {
            // split decimal part
            const part = number.toString().split(".");
            // add thousand separator
            let res = part[0].replace(/\B(?=(\d{3})+(?!\d))/g, numberDisplayFormat.thousandSeparator);
            // add decimal separator
            if (part[1]) res = res + numberDisplayFormat.decimalSeparator + part[1];
            return res;
        }
    };
    return formatNumber;
};


/***/ })

}]);